<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="javascript:void(0)">Partnership Management</a>
    <div class="collapse navbar-collapse">
      <a class="btn btn-sm btn-outline-primary ms-auto" [routerLink]="['/lo', company_uuid, 'partnership', 'form']">&#43; Add Partner</a>
    </div>
  </div>
</nav>
<hr/>

<div class="card border-0 border-bottom rounded-0 mb-3">
  <div class="card-body">
    <div class="row g-3 align-items-end">
      <div class="col-auto">
        <label class="form-label fw-semibold">From</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filter.from">
      </div>
      <div class="col-auto">
        <label class="form-label fw-semibold">To</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="filter.to">
      </div>
      <div class="col-auto">
        <button class="btn btn-sm btn-primary" (click)="loadDashboard()" [disabled]="is_loading_dashboard">
          <span *ngIf="is_loading_dashboard" class="spinner-border spinner-border-sm me-1"></span>
          Refresh
        </button>
      </div>
    </div>
  </div>
</div>

<div class="row g-3 mb-3">
  <div class="col-6 col-lg-2">
    <div class="partnership-metric">
      <div class="metric-label">Partners</div>
      <div class="metric-value">{{dashboard.partners.length || 0}}</div>
    </div>
  </div>
  <div class="col-6 col-lg-2">
    <div class="partnership-metric">
      <div class="metric-label">Linked Codes</div>
      <div class="metric-value">{{matchedPartners()}}</div>
    </div>
  </div>
  <div class="col-6 col-lg-2">
    <div class="partnership-metric">
      <div class="metric-label">Referrals</div>
      <div class="metric-value">{{sum('total_referrals') | number:'1.0-0'}}</div>
    </div>
  </div>
  <div class="col-6 col-lg-2">
    <div class="partnership-metric">
      <div class="metric-label">Deposit</div>
      <div class="metric-value text-success">{{sum('total_deposit') | number:'1.2-2'}}</div>
    </div>
  </div>
  <div class="col-6 col-lg-2">
    <div class="partnership-metric">
      <div class="metric-label">Withdraw</div>
      <div class="metric-value text-danger">{{sum('total_withdraw') | number:'1.2-2'}}</div>
    </div>
  </div>
  <div class="col-6 col-lg-2">
    <div class="partnership-metric">
      <div class="metric-label">Transactions</div>
      <div class="metric-value">{{sum('total_transactions') | number:'1.0-0'}}</div>
    </div>
  </div>
</div>

<div class="card rounded-0 mb-3">
  <div class="card-header bg-dark text-white">Partnership Data</div>
  <div class="table-responsive">
    <table class="table table-sm table-hover mb-0">
      <thead>
        <tr>
          <th>Partner</th>
          <th>Referral Code</th>
          <th>Linked Player</th>
          <th class="text-end">Referrals</th>
          <th class="text-end">Deposit</th>
          <th class="text-end">Withdraw</th>
          <th class="text-end">Transactions</th>
          <th>Last Transaction</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let partner of dashboard.partners">
          <td>
            <div class="fw-semibold">{{partner.name}}</div>
            <a class="small text-muted" [href]="partner.link" target="_blank">{{partner.link}}</a>
          </td>
          <td>
            <span *ngIf="partner.referral_code" class="badge bg-secondary">{{partner.referral_code}}</span>
            <span *ngIf="!partner.referral_code" class="text-muted">No code in link</span>
          </td>
          <td>
            <span *ngIf="partner.partner_player_id">{{partner.partner_player_name || '-'}}</span>
            <span *ngIf="!partner.partner_player_id" class="text-warning">Not matched</span>
          </td>
          <td class="text-end">{{partner.total_referrals || 0}}</td>
          <td class="text-end text-success">{{(partner.total_deposit || 0) | number:'1.2-2'}}</td>
          <td class="text-end text-danger">{{(partner.total_withdraw || 0) | number:'1.2-2'}}</td>
          <td class="text-end">{{partner.total_transactions || 0}}</td>
          <td>{{partner.last_transaction_at || '-'}}</td>
        </tr>
        <tr *ngIf="!is_loading_dashboard && dashboard.partners.length == 0">
          <td colspan="8" class="text-center text-muted py-4">No partnership data found</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card rounded-0 mb-3">
  <div class="card-header bg-dark text-white">Recent Partnership Transactions</div>
  <div class="table-responsive">
    <table class="table table-sm table-hover mb-0">
      <thead>
        <tr>
          <th>Date</th>
          <th>Partner</th>
          <th>Player</th>
          <th>Type</th>
          <th>Bank</th>
          <th>Reference</th>
          <th class="text-end">Debit</th>
          <th class="text-end">Credit</th>
          <th class="text-end">Balance</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tx of dashboard.transactions">
          <td>{{tx.timestamp}}</td>
          <td>{{tx.partner_code}} - {{tx.partner_name}}</td>
          <td>{{tx.player_code}} - {{tx.player_name}}</td>
          <td>
            <span class="badge" [class.bg-success]="tx.type == 'topup'" [class.bg-danger]="tx.type == 'withdraw'">{{tx.type}}</span>
          </td>
          <td>{{tx.bank_name || '-'}}</td>
          <td>{{tx.trans_ref || '-'}}</td>
          <td class="text-end text-success">{{(tx.debit || 0) | number:'1.2-2'}}</td>
          <td class="text-end text-danger">{{(tx.credit || 0) | number:'1.2-2'}}</td>
          <td class="text-end">{{(tx.balance || 0) | number:'1.2-2'}}</td>
        </tr>
        <tr *ngIf="!is_loading_dashboard && dashboard.transactions.length == 0">
          <td colspan="9" class="text-center text-muted py-4">No partnership transactions found for this period</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card rounded-0">
  <div class="card-header bg-dark text-white">Partner Link Settings</div>
  <div class="card-body p-0">
    <app-tablev2 #table></app-tablev2>
  </div>
</div>
